import React from "react";
import "../styles/SignInRootUser.css";
import EmailIcon from "../icons/SignInIcon/EmailIcon.js";
import SelectCyrcleIcon from "../icons/SignInIcon/SelectCyrcleIcon.js";
import { useState } from "react";
import SelectedCyrcleIcon from "../icons/SignInIcon/SelectedCyrcleIcon.js";
import Utils from "../utils/Utils.js";
import { useNavigate } from "react-router-dom";
import EyeView from "../icons/SignInIcon/EyeView.js";
import ShowIcon from "../icons/SignInIcon/ShowIcon.js";
import LockIcon from "../icons/SignInIcon/Lockicon.js";
import SignInVerification from "../components/SignInVerification.js";
import { useRef } from "react";
import userController from "../controllers/userController";
import { EncryptStorage } from "encrypt-storage";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { userService } from "../services/userService.js";
import companyController from "../controllers/companyController.js";
import XIcon from "../icons/XIcon.js";

function SignInRootUserWindow() {
  const encryptStorage1 = new EncryptStorage("secret-key", {
    prefix: "@instance1",
  });
  const encryptStorage2 = new EncryptStorage("secret-key1", {
    prefix: "@instance2",
  });
  const encryptStorage3 = new EncryptStorage("secret-key3", {
    prefix: "@instance3",
  });
  const encryptStorage4 = new EncryptStorage("secret-key4", {
    prefix: "@instance4",
  });
  const encryptStorage5 = new EncryptStorage("secret-key5", {
    prefix: "@instance5",
  });
  const inputRef = useRef(null);
  const passwordInputRef = useRef(null);
  const navigate = useNavigate();
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [showsignindiv, setShowSinInDiv] = useState(true);
  const [showverificationdiv, setVerificationDiv] = useState(true);
  const [email, setEmail] = useState("");
  const [select, setSelect] = useState(true);
  const [selected, setSelected] = useState(false);
  const [rememberpass, setRememberPass] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [upi, setupi] = useState("");
  const [jwt, setjwt] = useState("");
  const [forgetpass, setforgetpass] = useState(false);
  const [forgotPasswordStep, setForgotPasswordStep] = useState(1);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotPasswordOtp, setForgotPasswordOtp] = useState("");
  const [forgotOtpLoading, setForgotOtpLoading] = useState(false);
  const [forgotOtpError, setForgotOtpError] = useState("");
  const [resetNewPassword, setResetNewPassword] = useState("");
  const [resetConfirmPassword, setResetConfirmPassword] = useState("");
  const [resetPasswordLoading, setResetPasswordLoading] = useState(false);
  const [resetPasswordError, setResetPasswordError] = useState("");
  const [isForgotEmailValid, setIsForgotEmailValid] = useState(true);
  const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);
  useEffect(() => {
    inputRef.current?.focus();
  }, []);
  useEffect(() => {
    if (!showsignindiv && showverificationdiv && !forgetpass) {
      passwordInputRef.current?.focus();
    }
  }, [showsignindiv, showverificationdiv, forgetpass]);
  const handleIconClick = () => {
    inputRef.current?.focus();
  };
  const togglePassword = () => {
    setShowPassword(!showPassword);
  };
  const handlePass = (event) => {
    setRememberPass(event.target.checked);
  };
  const handleToggle = (type) => {
    if (type === "select") {
      const next = !select;
      setSelect(next);
      if (next) setSelected(false);
    }

    if (type === "selected") {
      const next = !selected;
      setSelected(next);
      if (next) setSelect(false);
    }
  };
  const onSignInClick = () => {
    try {
      const isValidEmail2 = Utils.checkEmailFormat(email);
      setIsValidEmail(isValidEmail2);
    } catch (error) {
      console.log(error);
    }
  };
  const handleNextClick = async () => {
    onSignInClick();

    try {
      const isValidEmail2 = Utils.checkEmailFormat(email);
      if (isValidEmail2) {
        const checkEmailRes = await userController.checkIfEmailInUse({
          email: email.toLowerCase(),
        });
        if (checkEmailRes.status === 200 && checkEmailRes.data === true) {
          setShowSinInDiv(false);
        } else {
          toast.error("Email does not exist");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleNextSubmit = async (event) => {
    event.preventDefault();
    await handleNextClick();
  };
  const handleSignClick = async () => {
    try {
      const authenticationRequest = {
        username: email.toLowerCase(),
        password: password,
      };
      const res = await userController.authenticateUser({
        authenticationDTO: authenticationRequest,
      });
      try {
        if (res && res.data.jwt) {
          const jwtToken = res.data.jwt;
          const parsed = Utils.parseJwt(res.data.jwt);
          encryptStorage3.setItem(
            "user-azalea",
            Object.keys(parsed.userDetails)[0],
          );
          const up = Utils.parseJwt(res.data.jwt);
          const userDetailsKeys = Object.keys(up.userDetails);
          const firstKey = userDetailsKeys[0];
          const isRoot = up.userDetails[firstKey];
          if (!isRoot) {
            toast.error("You are not a root user");
            return;
          }
          const upi = up.userDetails[firstKey].upi;
          setupi(upi);
          setjwt(res.data.jwt);
          encryptStorage1.setItem("user-azalea", res.data.jwt);
          // if (rememberpass) {
          //   encryptStorage1.setItem("password", password);
          // }
          encryptStorage5.removeItem("user-upi");
          const getPrimaryComp = async () => {
            if (!jwtToken) return;
            const userId = Utils.getUserIdFromJwt(parsed);
            if (!userId) return;
            const res = await companyController.userPrimaryCompanies({
              Authorization: jwtToken,
              userId,
            });

            const primaryCompanyID = res?.data?.[0]?.companyID;
            if (primaryCompanyID) {
              encryptStorage3.setItem("user-azalea", primaryCompanyID);
            }
            encryptStorage3.setItem("user-azalea", primaryCompanyID);

            const found = res?.data?.find(
              (c) => String(c.companyID) === String(primaryCompanyID),
            );

            encryptStorage4.setItem("user-azalea", found.businessProfileID);

            // if businessProfileID is on the company object, this is safe now
            // if (found?.businessProfileID != null) {
            //   encryptStorage4.setItem("user-azalea", found.businessProfileID);
            // } else {
            //   // optionally remove or set null to avoid stale value
            //   // encryptStorage4.removeItem("user-azalea");
            // }
          };
          getPrimaryComp();

          const enrollmultiA = {
            email: email.toLowerCase(),
            upi: upi,
          };
          const enrollMfaRes = await userController.enrollMfa({
            mfaDTO: enrollmultiA,
            jwt: res.data.jwt,
          });
          try {
            const msg = String(enrollMfaRes?.data?.message || "");
            const notEnforced = msg.toLowerCase().includes("mfa not enforced");

            if (Utils.isSuccessResponse(enrollMfaRes) && notEnforced) {
              toast.success(msg || "MFA NOT Enforced");
              // dataToSave.push(res.data.jwt);
              // if (rememberpass) {
              //   dataToSave.push(password, email);
              // }

              const dataToSave = {
                username: rememberpass ? email : null,
                password: rememberpass ? password : null,
                rememberpass: rememberpass,
              };

              encryptStorage2.setItem("user-data", dataToSave);
              encryptStorage1.setItem("user-azalea", res.data.jwt);
              navigate("/user-management");
              return;
            }
            if (
              Utils.isSuccessResponse(enrollMfaRes) &&
              enrollMfaRes.data.qrCodeBase64 !== null
            ) {
              toast.success(enrollMfaRes.data.message);
              const qrModal = document.getElementById("qrModal");
              const qrContainer = document.getElementById("qrCodeContainer");
              qrContainer.innerHTML = "";
              const img = document.createElement("img");
              img.src = `data:image/png;base64,${enrollMfaRes.data.qrCodeBase64}`;
              img.alt = "MFA QR Code";
              img.style.width = "200px";
              img.style.height = "200px";
              qrContainer.appendChild(img);
              qrModal.style.display = "flex";
              const closeModalBtn = document.getElementById("closeModalBtn");
              closeModalBtn.onclick = () => {
                qrModal.style.display = "none";
              };
              return;
            } else if (
              Utils.isSuccessResponse(enrollMfaRes) &&
              enrollMfaRes.data.qrCodeBase64 == null
            ) {
              setVerificationDiv(false);
              return;
            } else {
              toast.error(enrollMfaRes.data.message);
            }
          } catch (err) {
            toast.error(enrollMfaRes.response.data.message);
          }
        }
        // navigate("/user-management", {
        //   state: { jwt },
        // });
      } catch (err) {
        console.log(err);
        toast.error("Invalid email or password");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleSignSubmit = async (event) => {
    event.preventDefault();
    await handleSignClick();
  };
  useEffect(() => {
    const userData = userService.getUserObject();
    if (userData) {
      setEmail(userData.username);
      setPassword(userData.password);
      setRememberPass(userData.rememberpass);
    }
  }, []);

  const openForgotPassword = () => {
    setForgotPasswordStep(1);
    setForgotEmail(email);
    setForgotPasswordOtp("");
    setForgotOtpError("");
    setResetNewPassword("");
    setResetConfirmPassword("");
    setResetPasswordError("");
    setIsForgotEmailValid(true);
    setforgetpass(true);
  };
  const closeForgotPassword = () => {
    setforgetpass(false);
    setForgotPasswordStep(1);
    setForgotPasswordOtp("");
    setForgotOtpError("");
    setResetNewPassword("");
    setResetConfirmPassword("");
    setResetPasswordError("");
    setIsForgotEmailValid(true);
  };
  const handleForgotPassword = async (event) => {
    event.preventDefault();

    const normalizedEmail = forgotEmail.trim().toLowerCase();
    const emailIsValid = Utils.checkEmailFormat(normalizedEmail);
    setIsForgotEmailValid(emailIsValid);

    if (!emailIsValid || forgotPasswordLoading) return;

    try {
      setForgotPasswordLoading(true);
      const res = await userController.forgetpassword({
        source: "EMAIL",
        value: normalizedEmail,
      });

      if (Utils.isSuccessResponse(res) && res?.data.sent === true) {
        setForgotPasswordStep(2);
        toast.success("A verification code was sent to your email.", {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        const responseData = getResponseData(res);
        toast.error(
          responseData?.message ||
            "We could not send a verification code. Please try again.",
          {
            position: "top-right",
            autoClose: 3000,
          },
        );
      }
    } catch {
      toast.error("Something went wrong. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setForgotPasswordLoading(false);
    }
  };
  const verifyOTP = async () => {
    if (forgotPasswordOtp.length !== 6 || forgotOtpLoading) return;

    try {
      setForgotOtpLoading(true);
      setForgotOtpError("");

      const verifyResponse = await userController.verifyEmailOtp({
        verifyOtpDTO: {
          email: forgotEmail.trim().toLowerCase(),
          otp: forgotPasswordOtp,
        },
      });
      const responseData = getResponseData(verifyResponse);

      if (responseData?.message === "OTP Verified") {
        setForgotPasswordStep(3);
        return;
      }

      setForgotOtpError(
        responseData?.message || "The verification code is incorrect.",
      );
    } catch (error) {
      setForgotOtpError(
        error?.response?.data?.message ||
          "Verification failed. Please try again.",
      );
    } finally {
      setForgotOtpLoading(false);
    }
  };

  const handleSetForgottenPassword = async (event) => {
    event.preventDefault();

    const passwordRulesAreValid =
      resetNewPassword.length >= 8 &&
      /[A-Z]/.test(resetNewPassword) &&
      /[a-z]/.test(resetNewPassword) &&
      /\d/.test(resetNewPassword) &&
      /[^A-Za-z0-9]/.test(resetNewPassword);

    if (!passwordRulesAreValid) {
      setResetPasswordError(
        "Use at least 8 characters with uppercase, lowercase, number, and special character.",
      );
      return;
    }

    if (resetNewPassword !== resetConfirmPassword) {
      setResetPasswordError("The passwords do not match.");
      return;
    }

    if (resetPasswordLoading) return;

    try {
      setResetPasswordLoading(true);
      setResetPasswordError("");

      const setPasswordResponse = await userController.setPassword({
        setPasswordDTO: {
          emailOrPhone: forgotEmail.trim().toLowerCase(),
          newPassword: resetNewPassword,
          confirmPassword: resetConfirmPassword,
          otp: forgotPasswordOtp,
        },
      });

      if (Utils.isSuccessResponse(setPasswordResponse)) {
        setEmail(forgotEmail.trim().toLowerCase());
        toast.success("Your password has been reset. You can now sign in.", {
          position: "top-right",
          autoClose: 3000,
        });
        closeForgotPassword();
        return;
      }

      const responseData = getResponseData(setPasswordResponse);
      setResetPasswordError(
        responseData?.message || "Could not reset your password.",
      );
    } catch (error) {
      setResetPasswordError(
        error?.response?.data?.message ||
          "Could not reset your password. Please try again.",
      );
    } finally {
      setResetPasswordLoading(false);
    }
  };
  const getResponseData = (response) => {
    const data = response?.data || response?.response?.data || {};

    if (typeof data === "string") {
      try {
        return Utils.AESDecrypt(data);
      } catch {
        return data;
      }
    }

    return data;
  };
  return (
    <div className="root-signin-main-container">
      {forgetpass ? (
        <div
          className="forget-pass-popup-layer"
          role="presentation"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) closeForgotPassword();
          }}
        >
          <section
            className="forget-pass-popup"
            role="dialog"
            aria-modal="true"
            aria-labelledby="forget-pass-title"
          >
            <button
              className="forget-pass-close"
              type="button"
              aria-label="Close reset password dialog"
              onClick={closeForgotPassword}
            >
              <XIcon stroke="#667085" />
            </button>

            <div
              className="forget-pass-stepper"
              aria-label={`Step ${forgotPasswordStep} of 3`}
            >
              <span
                className={`forget-pass-step ${
                  forgotPasswordStep === 1 ? "is-active" : "is-complete"
                }`}
              >
                {forgotPasswordStep > 1 ? "✓" : "1"}
              </span>
              <span
                className={`forget-pass-step-line ${
                  forgotPasswordStep > 1 ? "is-complete" : ""
                }`}
              />
              <span
                className={`forget-pass-step ${
                  forgotPasswordStep === 2
                    ? "is-active"
                    : forgotPasswordStep > 2
                      ? "is-complete"
                      : ""
                }`}
              >
                {forgotPasswordStep > 2 ? "✓" : "2"}
              </span>
              <span
                className={`forget-pass-step-line ${
                  forgotPasswordStep > 2 ? "is-complete" : ""
                }`}
              />
              <span
                className={`forget-pass-step ${
                  forgotPasswordStep === 3 ? "is-active" : ""
                }`}
              >
                3
              </span>
            </div>

            {forgotPasswordStep === 1 ? (
              <>
                <div className="forget-pass-heading">
                  <div className="forget-pass-icon" aria-hidden="true">
                    <LockIcon />
                  </div>
                  <h2 id="forget-pass-title">Forgot your password?</h2>
                  <p>
                    No worries. Enter the email address linked to your account
                    and we’ll send you a verification code.
                  </p>
                </div>

                <form
                  className="forget-pass-form"
                  onSubmit={handleForgotPassword}
                >
                  <label htmlFor="forgot-password-email">
                    Email address <span>*</span>
                  </label>
                  <div
                    className={`forget-pass-email-field ${
                      isForgotEmailValid ? "" : "has-error"
                    }`}
                  >
                    <span className="forget-pass-email-icon" aria-hidden="true">
                      @
                    </span>
                    <input
                      id="forgot-password-email"
                      type="email"
                      autoComplete="email"
                      autoFocus
                      value={forgotEmail}
                      placeholder="Enter your email address"
                      aria-invalid={!isForgotEmailValid}
                      aria-describedby={
                        isForgotEmailValid ? undefined : "forgot-email-error"
                      }
                      onChange={(event) => {
                        setForgotEmail(event.target.value);
                        if (!isForgotEmailValid) setIsForgotEmailValid(true);
                      }}
                    />
                  </div>
                  {!isForgotEmailValid && (
                    <div className="forget-pass-error" id="forgot-email-error">
                      Please enter a valid email address
                    </div>
                  )}

                  <button
                    className="forget-pass-submit"
                    type="submit"
                    disabled={forgotPasswordLoading}
                  >
                    {forgotPasswordLoading
                      ? "Sending code..."
                      : "Send verification code"}
                  </button>
                  <button
                    className="forget-pass-back"
                    type="button"
                    onClick={closeForgotPassword}
                  >
                    <span aria-hidden="true">←</span> Back to sign in
                  </button>
                </form>
              </>
            ) : forgotPasswordStep === 2 ? (
              <>
                <div className="forget-pass-heading">
                  <div className="forget-pass-icon" aria-hidden="true">
                    <LockIcon />
                  </div>
                  <h2 id="forget-pass-title">Check your email</h2>
                  <p>
                    We sent a 6-digit verification code to{" "}
                    <strong>{forgotEmail.trim().toLowerCase()}</strong>
                  </p>
                </div>

                <form
                  className="forget-pass-form"
                  onSubmit={(event) => event.preventDefault()}
                >
                  <label htmlFor="forgot-password-otp">
                    Verification code <span>*</span>
                  </label>
                  <input
                    id="forgot-password-otp"
                    className="forget-pass-otp-input"
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    autoFocus
                    maxLength="6"
                    value={forgotPasswordOtp}
                    placeholder="000000"
                    onChange={(event) => {
                      setForgotPasswordOtp(
                        event.target.value.replace(/\D/g, "").slice(0, 6),
                      );
                      setForgotOtpError("");
                    }}
                  />
                  {forgotOtpError && (
                    <div className="forget-pass-error">{forgotOtpError}</div>
                  )}
                  <button
                    className="forget-pass-submit"
                    type="submit"
                    disabled={
                      forgotPasswordOtp.length !== 6 || forgotOtpLoading
                    }
                    onClick={() => verifyOTP()}
                  >
                    {forgotOtpLoading ? "Verifying..." : "Verify code"}
                  </button>
                  <button
                    className="forget-pass-back"
                    type="button"
                    onClick={() => {
                      setForgotPasswordStep(1);
                      setForgotPasswordOtp("");
                    }}
                  >
                    <span aria-hidden="true">←</span> Change email address
                  </button>
                </form>
              </>
            ) : (
              <>
                <div className="forget-pass-heading">
                  <div className="forget-pass-icon" aria-hidden="true">
                    <LockIcon />
                  </div>
                  <h2 id="forget-pass-title">Create a new password</h2>
                  <p>
                    Choose a strong password you havenâ€™t used for this account
                    before.
                  </p>
                </div>

                <form
                  className="forget-pass-form"
                  onSubmit={handleSetForgottenPassword}
                >
                  <label htmlFor="reset-new-password">
                    New password <span>*</span>
                  </label>
                  <div className="forget-pass-password-field">
                    <input
                      id="reset-new-password"
                      className="forget-pass-password-input"
                      type={showPassword ? "text" : "password"}
                      autoComplete="new-password"
                      autoFocus
                      value={resetNewPassword}
                      placeholder="Enter your new password"
                      onChange={(event) => {
                        setResetNewPassword(event.target.value);
                        setResetPasswordError("");
                      }}
                    />
                    <button
                      className="forget-pass-password-toggle"
                      type="button"
                      onClick={togglePassword}
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                    >
                      {showPassword ? <ShowIcon /> : <EyeView />}
                    </button>
                  </div>

                  <label
                    className="forget-pass-confirm-label"
                    htmlFor="reset-confirm-password"
                  >
                    Confirm new password <span>*</span>
                  </label>
                  <div className="forget-pass-password-field">
                    <input
                      id="reset-confirm-password"
                      className="forget-pass-password-input"
                      // type={showPassword ? "text" : "password"}
                      type="password"
                      autoComplete="new-password"
                      value={resetConfirmPassword}
                      placeholder="Confirm your new password"
                      onChange={(event) => {
                        setResetConfirmPassword(event.target.value);
                        setResetPasswordError("");
                      }}
                    />
                    {/* <button
                      className="forget-pass-password-toggle"
                      type="button"
                      onClick={togglePassword}
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                    >
                      {showPassword ? <ShowIcon /> : <EyeView />}
                    </button> */}
                  </div>

                  <div className="forget-pass-password-hint">
                    At least 8 characters with uppercase, lowercase, number, and
                    special character.
                  </div>
                  {resetPasswordError && (
                    <div className="forget-pass-error">
                      {resetPasswordError}
                    </div>
                  )}

                  <button
                    className="forget-pass-submit"
                    type="submit"
                    disabled={
                      !resetNewPassword ||
                      !resetConfirmPassword ||
                      resetPasswordLoading
                    }
                  >
                    {resetPasswordLoading
                      ? "Resetting password..."
                      : "Reset password"}
                  </button>
                  <button
                    className="forget-pass-back"
                    type="button"
                    onClick={() => {
                      setForgotPasswordStep(2);
                      setResetPasswordError("");
                    }}
                  >
                    <span aria-hidden="true">←</span> Back to verification
                  </button>
                </form>
              </>
            )}
          </section>
        </div>
      ) : null}
      {showsignindiv ? (
        <form className="root-signin" onSubmit={handleNextSubmit}>
          <div className="signin-heading">
            <div className="signin-heading-title">Sign In</div>
            <div className="signin-heading-text">
              Access your account by user type
            </div>
          </div>
          <div className="signin-usertype-selection">
            <div
              className={
                select
                  ? "signin-user-container-root-selected"
                  : "signin-user-container-root"
              }
              onClick={() => handleToggle("select")}
            >
              <div className="select-icon">
                {select ? <SelectedCyrcleIcon /> : <SelectCyrcleIcon />}
              </div>
              <div className="user-selection">
                <div className="selection-title">Root User</div>
                <div className="selection-text">
                  Account owner that performs tasks requiring unrestricting
                  Access.
                </div>
              </div>
            </div>
            <div
              className={
                selected
                  ? "signin-user-container-upi-selected"
                  : "signin-user-container-upi"
              }
              onClick={() => {
                handleToggle("selected");
                navigate("/");
              }}
            >
              <div className="select-icon">
                {selected ? <SelectedCyrcleIcon /> : <SelectCyrcleIcon />}
              </div>
              <div className="user-selection">
                <div className="selection-title">UPI User</div>
                <div className="selection-text">
                  User within an account that performs daily tasks.
                </div>
              </div>
            </div>
          </div>
          <div className="root-email-input-container">
            <div className="email-input-title">
              Email Address<div className="required">*</div>
            </div>
            <div className="root-signin-input-container">
              <div className="email-icon" onClick={handleIconClick}>
                <EmailIcon />
              </div>
              <input
                className="root-signin-input"
                ref={inputRef}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              ></input>
            </div>
            <div
              className="rong-email"
              style={{ display: isValidEmail ? "none" : "flex" }}
            >
              Please enter a valid email address
            </div>
          </div>
          <button className="next-action-bottom" type="submit">
            Next
          </button>
          <div className="dont-have-acc-container-responsive">
            <div className="dont-have-acc-container-text-responsive">
              Don’t have an account?
            </div>
            <div
              className="dont-have-acc-container-link-responsive"
              onClick={() => {
                window.open(
                  `${process.env.REACT_APP_DEV_ENVIROMET_URL}/register`,
                  "_blank",
                );
              }}
            >
              Sign UP
            </div>
          </div>
          <div className="terms-and-conditions">
            <div className="terms-and-conditions-text">
              By creating an account, you agree to Azalea’s{" "}
              <div className="terms-of-use">Terms of Use</div> and{" "}
              <div className="privacy-policy">Privacy Policy</div>.
            </div>
          </div>
        </form>
      ) : (
        <div className="root-user-signin-main-container">
          {showverificationdiv ? (
            <form
              className="root-user-signin-container"
              onSubmit={handleSignSubmit}
            >
              <div className="signin-verification-title-root">Sign In</div>
              <div className="root-signin-window-data-in-password-container">
                <div className="signin-window-data-in-title">
                  Password <div className="required">*</div>
                </div>
                <div className="signin-window-data-in-password">
                  <div className="signin-window-data-in-password-text">
                    <div className="signin-password-icon">
                      <LockIcon />
                    </div>
                    <input
                      className="signin-window-password-input"
                      ref={passwordInputRef}
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="current-password"
                      placeholder=""
                    ></input>
                  </div>
                  <div className="eye-view-content">
                    <button
                      className="eye-icon"
                      type="button"
                      onClick={togglePassword}
                      aria-label={showPassword ? "Hide password" : "Show password"}
                    >
                      {showPassword ? <ShowIcon /> : <EyeView />}
                    </button>
                  </div>
                </div>
                <div className="signin-window-footer">
                  <div className="signin-window-remember-main-container">
                    <div className="signin-window-footer-remember">
                      <input
                        className="signin-window-datain-footer-remember-checkbox"
                        type="checkbox"
                        checked={rememberpass}
                        onChange={handlePass}
                      ></input>
                      <div>Remember password</div>
                    </div>
                  </div>
                  <div
                    className="signin-window-forgetpass"
                    onClick={openForgotPassword}
                  >
                    Forget Password?
                  </div>
                </div>
              </div>
              <button className="signin-action-bottom" type="submit">
                Sign In
              </button>
              <div className="terms-and-conditions">
                <div className="terms-and-conditions-text">
                  By creating an account, you agree to Azalea’s{" "}
                  <div className="terms-of-use">Terms of Use</div> and{" "}
                  <div className="privacy-policy">Privacy Policy</div>.
                </div>
              </div>
              <div
                className="qrModel"
                id="qrModal"
                style={{
                  display: "none",
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(0,0,0,0.5)",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    background: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    textAlign: "center",
                  }}
                >
                  <h3>MFA QR Code</h3>
                  <div className="qr-code-container" id="qrCodeContainer"></div>
                  <button
                    type="button"
                    onClick={() => {
                      setVerificationDiv(false);
                    }}
                    id="closeModalBtn"
                  >
                    Close
                  </button>
                </div>
              </div>
            </form>
          ) : (
            <div className="root-signin-verification-main-container">
              <SignInVerification upivalue={upi} jwt={jwt} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default SignInRootUserWindow;
